export const SUPPLIER_AVAILABLE_IN = Object.freeze([
  { value: 'none', label: 'None' },
  { value: 'PHARMA_DISPENSE', label: 'Available for Pharma Dispense' },
]);